import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import ProductSales from '../../../../views/ProductSales/ProductSales.js';

const ProductSalesRoute = () => {
	return (
		<Routes>
			<Route path="" element={<ProductSales />} />
		</Routes>
	);
};

export default ProductSalesRoute;
